import React from "react";
import classNames from "classnames";
import Tooltip from "../Tooltip";
import "./index.scss"
import { tooltipicon } from "../../assets/images";

const RadioButton = ({
    checked,
    containerStyle,
    id,
    disabled,
    onChange,
    label,
    className,
    name,
    tabIndex,
    value,
    labelClassName,
    ref,
    title,
    tooltip,
}) => {

    return (
        <div
            className={`radio-item-custom ${className}`}
            style={containerStyle}
            ref={ref}
            tabIndex={tabIndex}
            title={title}
        >
            <input
                type="radio"
                id={id}
                name={name}
                onChange={onChange}
                disabled={disabled}
                checked={checked}
                value={value}
            />
            <label htmlFor={id} className={classNames("radioformLabel", labelClassName)}>
                {label}
                {tooltip && (
                    <Tooltip content={tooltip} direction="top" crossIcon={false} delay={200} classnames="radio-tooltip-tip">
                        <img 
                            src={tooltipicon}
                            className="radio-tooltip-icon"
                        />
                    </Tooltip>
                )}
            </label>
        </div>
    )
}

export default RadioButton;